import type { DocPageContent } from '../docs-content'

const page = {
  order: 14,
  slug: 'transitions',
  title: '转场',
  description:
    '将转场应用到切口，并调整其样式、时长、位置、缓动与方向。',
  category: '创意工具',
  related: ['timeline', 'effects-color'],
  sections: [
    {
      title: '应用转场',
      blocks: [
        {
          kind: 'steps',
          items: [
            '打开媒体侧边栏中的**转场**标签页。',
            '将转场卡片拖到两个相邻片段之间的切口上——或者选中一个有效切口并点击卡片。',
            '在时间轴上选中该转场，以打开属性中的**转场**部分。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '当两个片段首尾相接，并且有足够的空闲源帧可以重叠时，该切口才有效。应用在已有转场之上会就地替换它。',
        },
      ],
    },
    {
      title: '选择外观',
      blocks: [
        {
          kind: 'paragraph',
          text: '卡片按分类分组：**基础**、**溶解**、**运动**、**擦除**、**滑动**、**翻转**、**遮罩**、**光圈**、**形状**、**光线**和**色差**。',
        },
        {
          kind: 'list',
          items: [
            '溶解样式从普通的交叉溶解到叠加、模糊和色彩过渡变体不等。',
            '运动与自定义样式包括翻转、漏光、像素化、色差、径向模糊、故障和闪光。',
            '方向性样式（如擦除、滑动和翻转）会以多个卡片形式出现，每个方向一张。',
          ],
        },
      ],
    },
    {
      title: '调整转场',
      blocks: [
        {
          kind: 'table',
          headers: ['控件', '作用'],
          rows: [
            ['预设', '在不重做切口的情况下切换转场样式。'],
            ['时长', '设置转场持续时间；重置会将其恢复为 1 秒。'],
            ['位置', '以切口为中心，或将转场前移或后移。'],
            ['缓动', '线性、入、出，或入出。'],
            ['方向', '左、右、上或下，适用于方向性样式。'],
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: '你也可以直接拖动时间轴上转场的边缘来调整其大小。',
        },
      ],
    },
    {
      title: '转场无法应用时',
      blocks: [
        {
          kind: 'note',
          tone: 'warning',
          text: '你需要两个片段之间有真正的切口，并且在相关一侧有足够的**源余量**。如果某个位置被阻止，请选择另一个位置或减小修剪量。即便点击应用不可用，拖拽到有效切口上也始终有效。',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
